import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-sage/10 last:border-0" data-id="element-551">
      <button className="w-full py-6 px-6 flex items-center justify-between text-left focus:outline-none bg-white hover:bg-cream transition-colors" onClick={onClick} aria-expanded={isOpen} data-id="element-552">
        <span className="font-serif font-bold text-sage text-lg pr-4" data-id="element-553">
          {question}
        </span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-gold flex-shrink-0" data-id="element-554" /> : <ChevronDown className="h-5 w-5 text-gold flex-shrink-0" data-id="element-555" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-556">
        <div className="p-6 pt-0 text-sage/80 bg-white leading-relaxed" data-id="element-557">
          {answer}
        </div>
      </div>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handleClick = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="w-full bg-white rounded-2xl shadow-lg border border-sage/5 overflow-hidden" data-id="element-558">
      {items.map((item, index) => <AccordionItem key={index} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => handleClick(index)} data-id="element-559" />)}
    </div>;
}